import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { Button } from 'src/components/design-system';
import { useUploadContextFactory } from './upload-contexts/use-upload-context-factory';
import CSVFileUpload from './csv-file-upload';
import ColumnMapper from './column-mapper';
import DataValidator from './data-validator';
import UploadResults from './upload-results';
import { STAGES } from './use-upload';
import styles from './csv-upload-wizard.module.scss';
import { useSelector } from 'react-redux';
import { getLang } from 'shared/store/selectors/lang.selector';

const STAGES_ORDER = [STAGES.UPLOAD, STAGES.MAP, STAGES.VALIDATE, STAGES.RESULTS];

export const UploadComponent = ({ contextType }) => {
  const { stage, goBack } = useUploadContextFactory({ contextType });
  const lang = useSelector(getLang('SETTINGS'));

  const STAGE_LABELS = {
    [STAGES.UPLOAD]: lang.STAGE_FILE_UPLOAD,
    [STAGES.MAP]: lang.STAGE_COLUMN_MAPPING,
    [STAGES.VALIDATE]: lang.STAGE_DATA_VALIDATION,
    [STAGES.RESULTS]: lang.STAGE_RESULTS,
  };
  const showBackButton = ![STAGES.UPLOAD, STAGES.RESULTS].includes(stage);

  const getPreviousStageName = () => {
    const currentIndex = STAGES_ORDER.indexOf(stage);
    if (currentIndex > 0) {
      return STAGE_LABELS[STAGES_ORDER[currentIndex - 1]];
    }
    return '';
  };

  const renderStage = () => {
    switch (stage) {
      case STAGES.RESULTS:
        return <UploadResults contextType={contextType} />;
      case STAGES.VALIDATE:
        return <DataValidator contextType={contextType} />;
      case STAGES.MAP:
        return <ColumnMapper contextType={contextType} />;
      case STAGES.UPLOAD:
      default:
        return <CSVFileUpload contextType={contextType} />;
    }
  };

  return (
    <div className={styles.container}>
      {showBackButton && (
        <Button
          type="default"
          icon={<FontAwesomeIcon icon={faArrowLeft} />}
          onClick={goBack}
          className={styles.backButton}
        >
          {lang.BACK_TO} {getPreviousStageName()}
        </Button>
      )}
      {renderStage()}
    </div>
  );
};
